import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { CloseOutlined } from '@ant-design/icons';

export default function YouTubeModal(props) {
  return (
    <Modal
      open={props.showModal}
      onCancel={props.closeModal}
      footer={null}
      centered
      width={800}
      bodyStyle={{ padding: 0, backgroundColor: 'black' }}
    >
      <div
        style={{
          position: 'relative',
          paddingBottom: '56.25%',
          height: 0,
        }}
      >
        <iframe
          src={props.link}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Erklärvideo"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        />
      </div>
    </Modal>
  );
}

YouTubeModal.propTypes = {
  link: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
